import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Varaaha Application Runtime Error Caught:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="glass-panel error-boundary-card animate-fade-in">
            <div className="error-icon-circle">
              <AlertTriangle size={48} color="#f87171" />
            </div>
            <h2>Unexpected Application State</h2>
            <p className="error-desc">
              We encountered a temporary execution issue. Our technical monitoring team has logged this session.
            </p>

            <div className="error-actions">
              <button className="btn-primary" onClick={this.handleReload}>
                <RefreshCw size={18} />
                <span>Reload Application</span>
              </button>
              <button className="btn-secondary" onClick={this.handleGoHome}>
                <Home size={18} />
                <span>Return to Homepage</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
